// extracted by mini-css-extract-plugin
var _1 = "styles-module__menuItemRoot___Z7N0V";
export { _1 as "menuItemRoot" }
